// ==========================================================
// CARTES STATISTIQUES
// ==========================================================

export const ADMIN_ANALYTICS_STAT_CARDS = [
  {
    key: "total",
    title: "Total dossiers",
    color: "dark",
  },
  {
    key: "submitted",
    title: "Soumis",
    status: "submitted",
  },
  {
    key: "approved",
    title: "Validés",
    status: "approved",
  },
  {
    key: "rejected",
    title: "Refusés",
    status: "rejected",
  },
  {
    key: "draft",
    title: "Brouillons",
    status: "draft",
  },
];

// ==========================================================
// COULEURS DU GRAPHIQUE DES STATUTS
// ==========================================================

export const ANALYTICS_CHART_COLORS = [
  "#0d6efd",
  "#198754",
  "#ffc107",
  "#dc3545",
  "#6c757d",
];
